import { Link, useParams } from 'react-router-dom';
import { Box, Button, Container } from '@mui/material';

import { BagView } from '@widgets/view-bag/ui/BagView';
import React from 'react';

export const BagViewPage = () => {
    const { id } = useParams();

    return (
        <Container
            maxWidth="sm"
            className="no-scrollbar"
            sx={{
                width: { xs: '100%', md: 'auto' },
                padding: 2,
                overflowY: 'auto',
                height: '100%'
            }}
        >
            {/* Box for Back button */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start', // Align to the left
                    marginBottom: 2, // Add spacing below the button
                }}
            >
                <Button
                    variant="contained"
                    color="primary"
                    component={Link}
                    to="../bags"
                >
                    back
                </Button>
            </Box>

            {/* BagView Component */}
            <BagView bagId={id}/>
        </Container>
    );
};
